"use client";

import React from "react";
import RegisterForm from "@/components/pages/auth/register/register-form";
import Image from "next/image";
import image from "@/assets/auth/girl-image.png";
import styles from "./register-page.module.scss";
import { useMobile } from "@/hooks/use-responsive";

const RegisterPage = () => {
  const { isMobile } = useMobile();
  return (
    <div className={styles.wrapper}>
      <RegisterForm />
      {!isMobile && <Image className={styles.image} src={image} alt={"img"} />}
    </div>
  );
};

export default RegisterPage;
